import { create } from 'zustand';

import { SecureJsonBase } from '@/shared/lib/secure-json/core/secure-json-base';
import { CollectionItem } from '@/shared/lib/secure-json/core/secure-json-collection/types';
import { CollectionName } from '@/shared/lib/sj-orm/constants';

import { CollectionsSjMap } from '../types';

export enum OperationType {
  ADD = 'add',
  CHANGE = 'change',
  REMOVE = 'remove',
}

export type CollectionOperation = {
  operationType: OperationType;
  collectionName: CollectionName;
  item: CollectionItem;
};

type ISecureJsonCollectionsState = {
  operations: CollectionOperation[];
  collections: CollectionsSjMap;
};

export type ISecureJsonCollectionsStore = ISecureJsonCollectionsState & {
  setCollection: <T>(name: CollectionName, secureJsonBase: SecureJsonBase<T>) => void;
  changeCollectionItem: <T>(
    name: CollectionName,
    secureJsonBase: SecureJsonBase<T>,
    operation: CollectionOperation,
  ) => void;
  clearOperations: () => void;
  clear: () => void;
  // TODO remove logic from store
};

const getInitialState = (): ISecureJsonCollectionsState => ({
  collections: new Map(),
  // syncStatus: new Map(),
  operations: [],
});

export const useSecureJsonCollectionsStore = create<ISecureJsonCollectionsStore>((set) => ({
  ...getInitialState(),

  setCollection: (name, secureJsonBase) => {
    set((state) => {
      const collections = new Map(state.collections);
      collections.set(name, secureJsonBase);

      return { collections };
    });
  },
  changeCollectionItem: (name, collection, operation) => {
    set((state) => {
      const collections = new Map(state.collections);
      collections.set(name, collection);

      // const syncStatus = new Map(state.syncStatus);
      // syncStatus.set(name, false);

      const operations = state.operations.slice(0).concat(operation);

      return { collections, operations };
    });
  },
  clearOperations: () => set({ operations: [] }),
  clear: () => set(getInitialState()),
}));
